import React, { useState, useEffect } from 'react';
import { Modal, Button, Row, Col, Spinner } from 'react-bootstrap';
import { Autocomplete, TextField } from '@mui/material';
import { Formik, Form, Field, ErrorMessage } from 'formik';
import { Input } from 'reactstrap';
import { InputFormFiled } from '../../../components/Common/FormikField/InputFormFiled';
import { GetSchema, AuthCode } from '../../../js/Base/ValidationSchema';
import toastAlert from '../../../js/Base/ToastAlert';
import CloseIcon from '@mui/icons-material/Close';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import { store } from "../../../store/store"
import { useSelector, useDispatch } from "react-redux";
import { fetchCompanyLicense } from '../../../store/slices/licenseSlice';
import { cloudNativeEnabledSelector, crowdstrikeEnabledSelector } from "../../../store/selectors/licenseSelectors";
import { insertCompanyLicense } from '../../../api/keyApi';

const SystemAuthExpiredModal = ({ isModalOpen, handleClose, onUpdated, submitEffect, isCreate, configKey }) => {
  const titleStyle = {
    fontSize: '12px',
    color: '#323232',
    fontWeight: 'bold',
    marginTop: '20px',
    marginBottom: '13px',
    fontFamily: 'Noto Sans, sans-serif'
  };

  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(fetchCompanyLicense());
  }, []);

  const original_license = useSelector((state) => state.license.data);
  const formSchema = GetSchema({
    license: AuthCode(),
  });

  const handleSubmit = async (values, { setSubmitting }) => {
    try {
      const companyUuid = localStorage.getItem("company_uuid");
      const payload = {
        company_uuid: companyUuid,
        license_key: values.license,
      };
      const data = await insertCompanyLicense(payload);
      if (data.success) {
        toastAlert.autoClose(true).showSuccess("授權成功");
        onUpdated(true);
      } else {
        toastAlert.autoClose(true).showError("授權失敗，請稍後再試");
        onUpdated(false);
      }
    } catch (error) {
      if (error.__handled) return;
      toastAlert.autoClose(true).showError("授權失敗，請稍後再試");
      onUpdated(false);
    } finally {
      await dispatch(fetchCompanyLicense()).unwrap();
      setSubmitting(false);
      handleClose();
    }
  };

  return (
    <>
      <Modal
        animation="true"
        style={{ zIndex: '1299' }}
        show={isModalOpen}
        onHide={handleClose}
        className="CompanyManagement"
      >
        <Modal.Header>
          <Modal.Title className="modal-title">License key</Modal.Title>
        
          {/* 解決籃框問題，自訂MUI按鈕 */}
          <button
            onClick={handleClose}
            style={{
              background: 'transparent',
              border: 'none',
              cursor: 'pointer',
              padding: 0,
              marginLeft: 'auto'
            }}
          >
            <CloseIcon fontSize="medium" />
          </button>
        </Modal.Header>
        <Formik
          initialValues={{
            license: "",
            expiry_date: original_license?.expiry_date 
            ? new Date(original_license.expiry_date).toISOString().split("T")[0]
            : "",
          }}
          enableReinitialize
          validationSchema={formSchema}
          onSubmit={handleSubmit}
        >
          {({ handleSubmit, resetForm, setFieldValue, isSubmitting, errors, touched, values }) => (
            <Form className="form" style={{ padding:'0px' }}>
              <Modal.Body className="modal-body" style={{ paddingTop:'0px' }}>
                <Row>
                  <span className="text-danger" style={{ fontSize: "16px", paddingTop: "16px", color: "#FF6565" }}>
                    License key已到期，請輸入新的License key。
                  </span>

                  <Col md="12">
                    <p style={titleStyle}>License key到期日(UTC)</p>
                    <p style={{ fontSize: '14px', color: '#323232', paddingLeft:'10px', fontFamily: 'Noto Sans, sans-serif' }}>
                      {values.expiry_date ? values.expiry_date : ''}
                    </p>
                  </Col>
                  <Col md="12">
                    <InputFormFiled
                      title="新的License key"
                      className="input-field custom-select"
                      name="license"
                      type="textarea"
                      maxLength="600"
                      rows="7"
                      invalid={errors.license && touched.license}
                    />
                  </Col>
                </Row>
              </Modal.Body>
              <Modal.Footer className="modal-footer">
                <Button
                  type="button"
                  className="btn btn-cancel"
                  onClick={handleClose}
                  disabled={isSubmitting}
                >
                  取消
                </Button>
                <Button type="submit" className="btn btn-custom" disabled={isSubmitting} >
                  確認
                </Button>
              </Modal.Footer>
            </Form>
          )}
      </Formik>
      </Modal>
    </>
  );
};

export default SystemAuthExpiredModal;
